import {Controller, useForm} from "react-hook-form";
import {Box, InputAdornment, Stack, TextField, Typography} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import Button from "@mui/material/Button";
import React, {useState} from "react";
import {useParams} from "react-router";
import axios from "../../axiosConfig";
import {useNavigate} from "react-router-dom";
import { LoadingButton } from '@mui/lab';
import { useTranslation } from "react-i18next";

const loginFieldSx = {
  "& .MuiInputBase-root": {
    padding: 0,
    border: "1px solid #E4E9EF",
    borderRadius: "14px",
    overflow: "hidden",
    backgroundColor: "#fff",
    filter: "drop-shadow(0px 3px 3px rgba(0,0,0,0.16))",
  },
  "& input": {
    border: "none !important",
    filter: "none !important",
    boxShadow: "none !important",
    borderRadius: "0 !important",
  },
  "& .MuiInputAdornment-root": { m: 0 },
};

const CheckCodeForm = ()=>{
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const {
        handleSubmit,
        control,
        formState: { errors },
        setError,
    } = useForm({
        mode: "onChange",
    });
    const {userId, code} = useParams();
    const nav = useNavigate();
    const onSubmit = (data) =>{
        setIsLoading(true);
        axios.post(`/Auth/CheckCode`, {userId, code: data.code}).then(res=> {
            setIsLoading(false);
            nav(`/reset-password/${userId}/${data.code}`);
        }).catch(e=>{
            setError("code", {message: e.response.data.message})
            setIsLoading(false)
        });
    }
    return (
            <Stack sx={{p: 3, width: "90%", gap: 10  }}>
                <Typography
                    sx={{fontWeight: "bold", alignSelf: "center"}}
                    color="primary.main"
                    variant="h5"
                >
                    {t('checkCode_title')}
                </Typography>
                <Stack>
                    <Typography sx={{fontWeight: "bold"}}>{t('checkCode_label')}</Typography>
                    <Controller
                        name="code"
                        control={control}
                        rules={{
                            required: t('checkCode_required'),

                        }}
                        render={({field}) => (
                            <TextField
                                {...field}
                                variant="standard"
                                sx={loginFieldSx}
                                inputProps={{ style: { textAlign: "center", height: 48, padding: 0 } }}
                                InputProps={{
                                    disableUnderline: true,
                                    placeholder: t('checkCode_placeholder'),
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: 48,
                                                    height: 48,
                                                    backgroundColor: "#EAF0F7",
                                                }}
                                            >
                                                <PersonIcon color="primary"/>
                                            </Box>
                                        </InputAdornment>
                                    ),
                                }}
                                FormHelperTextProps={{
                                    sx: {
                                        textAlign: "start",
                                    },
                                }}
                                error={!!errors.code}
                                helperText={errors.code ? errors.code.message : ""}
                            />
                        )}
                    />

                </Stack>

                    <Typography
                        variant="caption"
                        sx={{fontWeight: "bold", alignSelf: "center"}}
                    >
                        {t('checkCode_smsHint')}
                    </Typography>
                <LoadingButton
                    type="sumbit"
                    loading={isLoading}
                    sx={{width: "80%", alignSelf: "center"}}
                    variant="contained"
                    onClick={handleSubmit(onSubmit)}
                >
                    <Typography>{t('checkCode_submit')}</Typography>
                </LoadingButton>
            </Stack>
    );
}
export default CheckCodeForm;